import {
  array,
  nullable,
  object,
  optional,
  passthrough,
  string,
  union,
} from "valibot";

const PassthroughObjectSchema = passthrough(object({}));

export const EventDataSchema = object({
  message: string(),
  instanceName: optional(string()),
  type: optional(string()),
  detailType: optional(string()),
  detail: optional(
    nullable(
      union([
        string(),
        array(PassthroughObjectSchema),
        PassthroughObjectSchema,
      ]),
    ),
  ),
});
